/* eslint-disable import/prefer-default-export */
import { checkPermission } from "@ROM/Permissions/utils";

export const canAccessCompanyAdmin = (user) => checkPermission(user, "company:admin:access");
